import { render, staticRenderFns } from "./attach_captain.vue?vue&type=template&id=ff77fe62&scoped=true&"
import script from "./attach_captain.vue?vue&type=script&lang=js&"
export * from "./attach_captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff77fe62",
  null
  
)

export default component.exports